import axios from 'axios';
const url = window.location.href;
const arr = url.split("/");
const result = arr[0] + "//" + arr[2];
class AuthApi {
  install(Vue) {
    Vue.prototype.$authApi = this;
    this._authApi = axios.create({
      crossDomain: true,
      headers: {
        'accept': 'application/json',
        'accept-language': 'en_US',
      },
      baseURL: result + '/wp-json/',
      timeout: 100000,
    });
  }

  checkIfLogged() {
    let thisRequest = this._authApi;
    thisRequest.interceptors.request.use(config => {
      config.headers['X-WP-Nonce'] = wpApiSettings.nonce;
      return config;
    });
    return new Promise((resolve, reject) => {
      thisRequest.get(`remcon/v1/logged`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  updateUser(id, data) {
    let thisRequest = this._authApi;
    thisRequest.interceptors.request.use(config => {
      config.headers['X-WP-Nonce'] = wpApiSettings.nonce;
      return config;
    });
    if (typeof data.password !== 'undefined') {
      return new Promise((resolve, reject) => {
        thisRequest.post(`remcon/v1/checkUserPassword`, {'user_id': id, 'password': data.password_current}
        ).then(function (response) {
          if (response.data.result === true) {
            resolve(new Promise((resolve, reject) => {
              thisRequest.post(`wp/v2/users/${id}`, data
              ).then(function (response) {
                resolve(true);
              }).catch(function (error) {
                reject(error.response.data);
              });
            }));
          } else {
            resolve(response.data.error);
          }
        }).catch(function (error) {
          reject(error.response.data);
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        thisRequest.post(`wp/v2/users/${id}`, data
        ).then(function (response) {
          resolve(true);
        }).catch(function (error) {
          reject(error.response.data);
        });
      });
    }
  }

  loginUser (data) {
    return new Promise((resolve, reject)  => {
      this._authApi.post(`remcon/v1/login`, data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  registerUser(data) {
    return new Promise((resolve, reject) => {
      this._authApi.post(`remcon/v1/register`, data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  logoutUser() {
    let thisRequest = this._authApi;
    thisRequest.interceptors.request.use(config => {
      config.headers['X-WP-Nonce'] = wpApiSettings.nonce;
      return config;
    });
    return new Promise((resolve, reject) => {
      thisRequest.get(`remcon/v1/logout`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  resetPassword(email) {
    return new Promise((resolve, reject) => {
      this._authApi.get(`remcon/v1/resetpassword?user_login=${email}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchGeneratorLayout(id) {
    return new Promise((resolve, reject) => {
      this._authApi.get(`remcon/v1/auth/generator/project/?id=${id}`,
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }
}

export default AuthApi;
